import React from 'react'
import { ThemeContext } from './../../theme/DarkMode';
import '@material/web/iconbutton/standard-icon-button.js';
import '@material/web/iconbutton/lib/icon-button';
import '@material/web/iconbutton/lib/shared-styles.css';
import '@material/web/iconbutton/lib/standard-styles.css';
import '@material/web/icon/icon.js';
import '@material/web/icon/lib/icon-styles.css';
import '@material/web/icon/lib/icon.js';
import { SocialMedia } from '../socialMedia/SocialMedia';
import { useTranslation } from 'react-i18next';

export const Footer = () => {

  const { theme } = React.useContext(ThemeContext);

  const { t } = useTranslation()

  const openAhilPost = () => {
    window.open('mailto:ahil.app.sup@gmail.com')
  }
  const handleClick = () => {
    window.open("https://logo.samandehi.ir/Verify.aspx?id=367137&p=xlaogvkajyoerfthxlaojyoe", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30");
  };
  return (
    <footer className={theme === 'light' ? 'light-footer-wrapper' : 'footer-wrapper'}>
      <div className='footer-contnent'>
        <div className='footer-details'>
          <h5 onClick={openAhilPost} style={{cursor: 'pointer'}}>{t('footer.electronic-post')}</h5>
          <h5>{t('footer.static-phone')}</h5>
          <h5>{t('footer.phone')}</h5>
          <h5>{t('footer.address')}</h5>
          <h5>{t('footer.postal-code')}</h5>
        </div>
        <div className='social-media-footer-wrapper'>
          <p className='social-title'>{t('footer.social-media')}</p>
          <SocialMedia/>
        </div>
        <div className='enamad-wrapper'>
          <a referrerPolicy="origin" target="_blank"
             href="https://trustseal.enamad.ir/?id=332039&amp;Code=b9tZVFW5zdJixFF6G87b">
            <img referrerPolicy="origin"
                 src="https://Trustseal.eNamad.ir/logo.aspx?id=332039&amp;Code=b9tZVFW5zdJixFF6G87b" alt="enamad"
                 id="b9tZVFW5zdJixFF6G87b"/>
          </a>
        </div>

        <img
            referrerPolicy='origin'
            id='rgvjfukzjzpejxlzrgvjjzpe'
            style={{cursor: 'pointer'}}
            onClick={handleClick}
            alt='logo-samandehi'
            src='https://logo.samandehi.ir/logo.aspx?id=367137&p=qftiwlbqyndtnbpdqftiyndt'
        />
      </div>
    </footer>
  )
}
